export const REFRESH_TOKEN_KEY = "refresh-token";
export const NOTIFICATIONS_ALERT_KEY = "notifications";
export const MESSAGE_VIEW_DATE = "message-date";
